module.exports = __webpack_public_path__ + "img/medal-gold.09eff00b.svg";